import React, { useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';

const CookiesBanner = ({ active, onClose, onCookieClickCount, accept }) => {
    let node = useRef();
    useEffect(() => {
        document.addEventListener('mousedown', handleOutsideClick);
        return () => document.removeEventListener('mousedown', handleOutsideClick);
    });
    const handleOutsideClick = e => {
        if (node.current && node.current.contains(e.target)) return;
        onCookieClickCount();
    };
    return active ? (
        <div className="cookies-banner" ref={node}>
            <div className="inner">
                <p>
                    {accept
                        ? 'Thank you for accepting our cookie policy, to view the policy'
                        : 'We use cookies to ensure we give you the best experience of our website, to accept click on any link or continue to browse. To find out more about the cookies we use'}{' '}
                    <Link to="/cookies">
                        <em>click here</em>
                    </Link>
                    .
                </p>
                <div onClick={() => onClose()} className="close">
                    X
                </div>
            </div>
        </div>
    ) : null;
};

export default CookiesBanner;
